import { ChainId } from 'symbiosis-js-sdk'

import Spinner from '~/components/Spinner'
import { renderAmount, toAmount } from '~/lib/helpers'
import { symbiosis } from '~/lib/symbiosis'

import styles from './YourLiquidity.pcss'
import { LP_TOKEN_DECIMALS } from '~/lib/constants'
import { useEffect } from 'react'
import { getPoolBalance } from '~/lib/getPoolBalance'
import { useWallet } from '~/lib/useWallet'
import { useSetState } from '~/hooks/useSetState'

interface Props {
	chainId: ChainId
	poolAddress: string
}

interface State {
	yourLiquidity: string
	yourLiquidityLoading: boolean
}

function YourLiquidity({ chainId, poolAddress }: Props) {
	const { account } = useWallet()

	const [state, setState] = useSetState<State>({
		yourLiquidity: '',
		yourLiquidityLoading: false,
	})

	useEffect(() => {
		if (!account) {
			return
		}

		const provider = symbiosis.getProvider(chainId)

		setState({ yourLiquidityLoading: true })

		getPoolBalance({
			account,
			provider,
			poolAddress,
		})
			.then((balance) => {
				const amount = toAmount(LP_TOKEN_DECIMALS, balance)
				setState({ yourLiquidityLoading: false, yourLiquidity: amount })
			})
			.catch(() => {
				setState({ yourLiquidityLoading: false, yourLiquidity: '' })
			})
	}, [account, chainId, setState])

	const { yourLiquidity, yourLiquidityLoading } = state

	if (yourLiquidityLoading) {
		return <Spinner className={styles.spinner} />
	}

	const yourLiquidityAmount = yourLiquidity
		? renderAmount(yourLiquidity, 2)
		: 0

	return <span>{account ? `$${yourLiquidityAmount}` : '-'}</span>
}

export default YourLiquidity
